export class DataPoint<D = any> {
    x: string | number;
    y: number;
    data: D;

    constructor(data?: D) {
        this.data = data;
    }
}
